import CaseletItem from "./CaseletItem";
import { useLocation, useNavigate } from "react-router-dom";
import { Caselet, delete_user_data_from_client_side, get_user_data, giveErrorMessage } from "../../utils/common";
// import { checkUser, getCaseletFileInfo, getPublishedCaseletsFiles, searchCaseletAPI } from "../../api";
import { useCallback, useEffect, useRef, useState } from "react";
import { loadNumberOfFiles } from "../../utils/appConstant";
import InfiniteScroll from "react-infinite-scroll-component";
import MultipleLoadingScreen from "../../design-system/MultipleLoadingScreen";
import { LuSendHorizonal } from "react-icons/lu";
import React from "react";
import "./CaseletItem.module.css";
import { checkUser, getCaseletFileInfo, getPublishedCaseletsFiles, searchCaseletAPI } from "../../api/axiosApi";
const CaseletList = () => {
    const [caselet, setCaselet] = useState<Caselet[]>([]);
    const textAreaRef = useRef<HTMLTextAreaElement>(null);
    const [userNotExist, setUserNotExist] = useState<boolean>(false);
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [statusCode, setStatusCode] = useState<number | undefined>();
    const [hasMore, setHasMore] = useState(true);
    const [textAreaValue, setTextAreaValue] = useState<string>("");
    const [publishedCaseletDirAvailable, setPublishedCaseletDirAvailable]  = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    let fileIndex = 0;

    const fetchAndSetCaselets = async () => {
        try {
            if (get_user_data() !== null && get_user_data() !== undefined) {
                // const check_user_dir = await checkUser();
                // const checkUserExist = await check_user_dir.data;
                // if (!checkUserExist.exists) {
                //     setUserNotExist(true);
                // }
                
                const caseletFilesResponse = await getPublishedCaseletsFiles();
                const caseletFiles = await caseletFilesResponse.data;
                if (caseletFiles.status == "error" || caseletFiles.message === "PUBLISHED_CASELET_DIR_NOT_AVAILABLE" || caseletFiles.length === 0) {
                    setPublishedCaseletDirAvailable(true);
                    setIsLoading(false)
                    return;
                } else {
                    setPublishedCaseletDirAvailable(false);
                }
                caseletFiles.sort((a: any, b: any) => {
                    const timestampA = Number(a.slice(0, -4)); 
                    const timestampB = Number(b.slice(0, -4)); // Remove '.txt' and convert to number
                    return timestampB - timestampA; // Sort in descending order (most recent first)
                });
                const fetchedCaselets: Caselet[] = [];
                let caseletInfoResponse: Response | undefined | any;
                for (let i = 0; i < Math.min(caseletFiles.length, loadNumberOfFiles) && fileIndex < caseletFiles.length; i++) {
                    try {
                        caseletInfoResponse = await getCaseletFileInfo(caseletFiles[fileIndex].substring(0, caseletFiles[fileIndex].lastIndexOf(".")));
                        const caseletInfo = await caseletInfoResponse.data;
                        if (caseletInfo.id === undefined) {
                            fileIndex++;
                            continue;
                        }
                        caseletInfo.fileName = caseletFiles[fileIndex].substring(0, caseletFiles[fileIndex].lastIndexOf("."));
                        fetchedCaselets.push(caseletInfo);
                    } catch (error) {
                        console.error(`Failed to fetch caselet data `, error);
                    }
                    fileIndex++;
                }

                setCaselet(prevCaselet => [...prevCaselet, ...fetchedCaselets]);
                setIsLoading(false);
                if (caseletFiles.length <= fileIndex) {
                    setHasMore(false);
                    return;
                }
            } else {
                navigate("/user_login");
            }
        } catch (error) {
            setError(true);
            console.error(`Failed to fetch caselet files `, error);
        }
    };

    const searchCaselets = useCallback(async () => {
        setHasMore(false);
        setIsLoading(true);
        if (textAreaValue.trim().length !== 0) {
            try {
                const res = await searchCaseletAPI(textAreaValue);
                const result = await res.data;
                console.log("result: ", result);
                const uniqueCitations = new Set();
                const newFilteredSeeds: any[] = [];
                for (let name of result.fileName) {
                    const filename = name;
                    try {
                        if (filename && !uniqueCitations.has(filename)) {
                            uniqueCitations.add(filename);
                            const Response = await getCaseletFileInfo(filename);
                            // if (!Response.ok) {
                            //     throw new Error(`Error! status: ${res.status}`);
                            // }
                            const seedInfo = await Response.data;
                            console.log("caseleinfo: ", seedInfo);
                            seedInfo.fileName = filename;
                            newFilteredSeeds.push(seedInfo);
                        }
                    } catch (error) {
                        console.error(`Failed to fetch seed files `, error);
                    }
                }
                setCaselet(newFilteredSeeds);
            } catch (error) {
                setError(true);
                console.error(`Failed to search seed files `, error);
            } finally {
                setIsLoading(false);
            }
        }
    }, [textAreaValue]);

    const handleKeyDown = useCallback(
        async (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
            if (event.key === "Enter" && !event.shiftKey) {
                event.preventDefault();
                if (textAreaValue.trim().length !== 0) await searchCaselets();
            }
        },
        [searchCaselets]
    );

    useEffect(() => {
        if (hasMore) {
            fetchAndSetCaselets();
        }
    }, [location]);
    const fetchMoreData = useCallback(() => {
        if (hasMore) {
            fetchAndSetCaselets();
        }
    }, [hasMore]);
    if (isLoading && error === false) {
        return (
            <div className="p-4">
                <MultipleLoadingScreen count={3} />
            </div>
        );
    }
    if (publishedCaseletDirAvailable) {
        return (
            <div className=" flex justify-center items-center pb-4 w-full h-full ">
                <p className="p-2 flex  justify-center text-slate-500 font-bold">There is nothing to show here.</p>
            </div>
        );
    }
    if (error) {
        return giveErrorMessage(statusCode);
    }
    return (
        <div className="relative flex h-full max-w-full flex-1 flex-col ">
            <div className="flex-1 pb-28">
                <InfiniteScroll
                    dataLength={caselet.length}
                    next={fetchMoreData}
                    hasMore={hasMore}
                    loader={
                        <div className="p-4">
                            <MultipleLoadingScreen count={3} />
                        </div>
                    }
                >
                    {caselet.map(caseletObject => (
                        <CaseletItem key={caseletObject.id} caselet={caseletObject} />
                    ))}
                </InfiniteScroll>
            </div>

            <div className="fixed bottom-0  md:pt-0 dark:border-white/20 w-[calc(100%-6rem)] juice:w-full html_bg_color min-w-80 bg-neutral-100">
                <div className="mt-3 flex items-center justify-center mb-3 ">
                    <textarea
                        ref={textAreaRef}
                        className="rounded-xl shadow-2xl w-8/12 resize-none border p-2 "
                        id="promptInput"
                        placeholder="Search caselets"
                        value={textAreaValue}
                        onChange={e => setTextAreaValue(e.target.value)}
                        onKeyDown={handleKeyDown}
                        autoFocus
                    />
                    <button onClick={searchCaselets} className="text-green-800 ml-2  p-2 ">
                        <LuSendHorizonal />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CaseletList;
